export default __webpack_public_path__ + "static/media/twitter-rounded.db4f5b0c.svg";